export const myLabels = [
  { label: 'Levels', value: 'level' },
  { label: 'Loyalty Point Start', value: 'startPoint' },
  { label: 'Loyalty Point End', value: 'endPoint' },
  { label: 'Cashback Percentage', value: 'bonusPercentage' },
  { label: 'Cashback Multiplier', value: 'cashback_multiplier' },
  { label: 'Max Bonus Claimed', value: 'maxBonusThreshold' },
  { label: 'Max Win Amount', value: 'maxWinAmount' }
]
